import styled, { css } from 'styled-components';

import { getFontStyle } from '~components/Text/helper';
import { HEADER_HEIGHT } from '~constant/layout';

export const cssModalWrapper = css`
  display: flex;
  align-items: center;
  width: 100%;
  top: 0;
  left: 0;
  transform: translate3d(0, 0, 0);
  position: relative;
  min-height: 80px;
  border-radius: 0;
`;

export const InputWrapper = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  height: 48px;
  border-radius: 999px;
  margin-left: 16px;
  padding: 0 16px 0 0;
  background-color: ${({ theme }) => theme.colors.gray300};

  ${({ theme }) => theme.media.tablet} {
    margin-left: 32px;
  }
`;

export const IconWrapper = styled.div`
  padding: 0 13px 0 18px;

  > * {
    vertical-align: top;
  }
`;

export const Input = styled.input`
  width: 100%;
  height: 48px;
  background: none;
  outline: none;
  color: ${({ theme }) => theme.colors.gray900};
  ${getFontStyle('midium150_B1')};

  &::placeholder {
    opacity: 1;
    color: ${({ theme }) => theme.colors.gray600};
  }
`;

export const ButtonClose = styled.a`
  display: flex;
  align-items: center;
  height: ${HEADER_HEIGHT}px;
  /* position: absolute;
  top: 0;
  right: 0; */
  padding: 0 16px;

  ${({ theme }) => theme.media.tablet} {
    padding: 0 32px;
  }
`;

export const cssAutosuggest = css`
  width: 100%;
  position: static;
  left: 0;
  margin-top: 0;
`;

export const cssAutosuggestList = css`
  width: 100vw;
  top: 64px;
  left: 0;
  margin-top: 0;
  border-width: 0;
  border-radius: 0;
  box-shadow: none;
  padding: 8px 16px 0;
`;
